export enum CardStatus {
Active,
Lost,
Damaged,
Expired,
}
